import { Action, Message } from "types/redux"
import { ConfigurationStore } from "types/store"
import {
  CONFIGURATION_ERROR,
  CONFIGURATION_REQUEST,
  CONFIGURATION_SUCCESS,
  ACTIVATE_MAINTENANCE,
  DEACTIVATE_MAINTENANCE
} from "./constant"

const initialState: ConfigurationStore = {
  success: false,
  loading: false,
}
const reducer = function configurationReducer(
  state = initialState,
  action: Action<ConfigurationStore | Message>
): ConfigurationStore {
  switch (action.type) {
    case CONFIGURATION_REQUEST:
      return { ...state, success: false, loading: true }
    case CONFIGURATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
        success: true,
        loading: false,
      }
    case CONFIGURATION_ERROR:
      return {
        ...state,
        message: action.payload as Message,
        success: false,
        loading: false,
      }
    case ACTIVATE_MAINTENANCE: 
      return {
        ...state, 
        maintenance: {
          active: true,
          checkAPI: true,
        }
      }
    case DEACTIVATE_MAINTENANCE: 
    return {
      ...state,
      maintenance: {
        active: false,
        checkAPI: false,
      }
    }
    default:
      return state
  }
}

export default reducer
